import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Compass02 = function Compass02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M22 12h-2m2 0c0 5.5228-4.4772 10-10 10m10-10c0-5.5228-4.4772-10-10-10m7.0711 17.0711-1.4142-1.4142M4 12H2m0 0c0 5.5228 4.4772 10 10 10M2 12C2 6.4772 6.4772 2 12 2M6.3431 6.3431 4.929 4.929M12 4V2m5.6569 4.3431 1.4142-1.4142M12 22v-2m-7.071-.9289 1.4141-1.4142M12 8l4 4-4 4-4-4z"
    })
  }));
};
export default Compass02;